import styled, { keyframes, css } from 'styled-components'

const v4 = css`
  --search-input-height: 46px;

  input {
    border: 1px solid var(--grey-2);
    border-bottom: 1px solid var(--black);
    border-radius: 0;

    &:focus {
      border: 1px solid var(--grey-2);
      border-bottom: 1px solid var(--black);
    }
  }

  button {
    margin-left: 0px;
    border-radius: 0;
  }
`

const glow = keyframes`
  from {
    background-color: #fff;
  }

  to {
    background-color: #ffe799;
  }
`

const Input = styled.div`
  display: flex;
  justify-content: center;

  input {
    width: var(--search-input-width);
    height: var(--search-input-height);
    box-shadow: none !important;
    background: var(--clr-grey-8-to-grey-0);
    padding: 0 var(--spacing-4);
    border: none;
    border: 1px solid var(--clr-accent-to-black);
    border-radius: var(--border-radius);
    outline: none;

    ${props =>
      props.highlight &&
      css`
        animation: ${glow} 400ms ease-out infinite alternate;
      `}

    &::placeholder {
      color: #415b65;
    }

    &:focus {
      border: none;
      border: 1px solid var(--clr-accent-to-black);
    }
  }

  button {
    background: var(--search-button-bg);
    cursor: pointer;
    margin-left: 10px;
    width: var(--search-input-height);
    height: var(--search-input-height);
    outline: 0;
    border: none;
    border-radius: var(--border-radius);
    color: var(--clr-grey-3-to-black);

    svg {
      fill: var(--clr-white-to-black);
      height: 56px;
    }

    ${props =>
      props.highlight &&
      css`
        animation: ${glow} 400ms ease-out infinite alternate;
      `}
    .fa {
      position: relative;
      top: 0px;
      font-size: 16px;
    }
  }
  ${props => props.version === 'v4' && v4}
`

export default Input



// WEBPACK FOOTER //
// ./src/components/SearchBar/Input.js